<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Migrar ' | translate}} {{ nomeModal }}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <ion-card class="gradient-extendido-recuo" *ngIf="dataSelect.length">
    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="auto">
          <p>
            {{'Selecione as carteirinhas que devem permanecer ativas após a pessoa ser migrada!' | translate}}
            <span class="danger">{{'Atenção! A pessoa será removida das carteirinhas não selecionadas!' | translate}}</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card-content class="remove-border">
      <ion-list>
        <ion-item *ngFor="let data of dataSelect;">
          <ion-toggle justify="space-between" [(ngModel)]="data.selected" [disabled]="data.disable" class="item-title" [enableOnOffLabels]="true">
            {{data.nome}}
          </ion-toggle>
        </ion-item>
      </ion-list>
    </ion-card-content>

    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="auto">
          <div>
            <ion-button expand="block" class="btn-default" (click)="selectData();">
              {{'Selecionar' | translate}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>

  <ion-grid *ngIf="!dataSelect.length">
    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <sem-registro></sem-registro>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
